export default __webpack_public_path__ + "static/media/chigo-screenshot-04.d6534d59.png";